import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
  
import colors from 'vuetify/lib/util/colors'

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#1FA4F4",
        secondary: colors.grey.darken1,
        accent:  '#1FA4F4',
        error: colors.red.accent3,
        background: '#EFEFEF',
        secondaryBackground: '#C4C4C4',
        accentElementBackground: colors.white,
        accentElement: '#949191',
        primaryAction: '#1FA4F4',
        secondaryAction: '#636262',
        toolbarButtonBackground: '#BCB9B9',
        green: '#78BB4F',
        red: '#E62828'
      }
    },
  },
});
